import MetaStore from './MetaStore';

export * from './MetaStore.dto';
export default new MetaStore();
